import { CustomerFleetType } from "@shared-features/enums/customer-fleet-type.enum";
import { Model } from "@shared-features/models/model";
import { Expose } from "class-transformer";

export class GlobalAndSpecificFleetsAndContractsCounts extends Model {
    @Expose() fleetType:           CustomerFleetType;
    @Expose() totalFleetsCount:    number;
    @Expose() totalContractsCount: number;
}
